import { useEffect, useState } from 'react'

export type VGSForm = {
  submit?: (path, opts, response, error) => void
  field?: (name, opts) => VGSField
}

export type VGSField = {
  mask?: (pattern: string) => void
}

export const useVgs = () => {
  const [isLoaded, setIsLoaded] = useState(false)
  useEffect(() => {
    const script = document.createElement('script')
    script.src =
      'https://js.verygoodvault.com/vgs-collect/1/ACm8vXoovXuVGTD1c5FWawpx.js'
    script.async = true
    script.onload = () => setIsLoaded(true)
    document.body.appendChild(script)
  })

  return isLoaded
}

export const useVgsForm = (isLoaded, setIsSsnValid) => {
  const [form, setForm] = useState(null)

  useEffect(() => {
    if (isLoaded) {
      setForm(
        window.VGSCollect.create('tnt6lmmk3ml', state => {
          setIsSsnValid(state.ssn.isValid)
        })
      )
    }
  }, [isLoaded])

  return form as VGSForm
}
